import { Fla_Fldr } from '../datapoint/fla_fldr';
import { CommonEnums } from '../../common.enums';

export class Fla_FldrsUtil {
    private static instance: Fla_FldrsUtil;

    static getInstance() {
        if (!Fla_FldrsUtil.instance) {
            Fla_FldrsUtil.instance = new Fla_FldrsUtil();
        }

        return Fla_FldrsUtil.instance;
    }

    /**
    * * private constructor().
    *  @description Fla_FldrsUtil is a singleton class, so use `Fla_FldrsUtil.getInstance()` method instead of creating new Fla_FldrsUtil().
    * ```
    *   It is a Singleton Class.
    *   Use  for usage notes.
    * ```
    * - `.class`: Select by class name.
    * - point2
    * ### Example
    *
    * this.fla_FldrsUtil = Fla_FldrsUtil.getInstance();
    *
    * @see [Forms](guide/reactive-forms)
    *
    * @see [Services](app/shared/services/service.manager)
    */

    private constructor() {

    }

    getPrimaryKey(fla_Fldr: Fla_Fldr): string {
        return fla_Fldr.fldr_Id + '.' + fla_Fldr.flagent_Id;
    }

    delete(fla_Fldr: Fla_Fldr, fla_Fldrs: Array<Fla_Fldr>): Fla_Fldr {
        for (var i: number = 0; i < fla_Fldrs.length; i++) {
            let fla_FldrTmp: Fla_Fldr = fla_Fldrs[i];
            if (this.getPrimaryKey(fla_Fldr) == this.getPrimaryKey(fla_FldrTmp)) {
                fla_Fldrs.splice(i, 1);
                return fla_FldrTmp;
            }
        }

        return null;
    }

    copy(fla_FldrsTmp: Array<Fla_Fldr>): Array<Fla_Fldr> {
        let fla_Fldrs: Array<Fla_Fldr> = new Array<Fla_Fldr>();

        for (var i: number = 0; i < fla_FldrsTmp.length; i++) {
            let fla_Fldr: Fla_Fldr = fla_FldrsTmp[i] as Fla_Fldr;
            fla_Fldrs.push(fla_Fldr.copy())
        }

        return fla_Fldrs;
    }

    copyFrom(fla_Fldrs: Array<Fla_Fldr>, fla_FldrsTmp: Array<Fla_Fldr>): void {
        let fla_FldrsMap: Map<string, Fla_Fldr> = new Map<string, Fla_Fldr>();

        for (let i: number = 0; i < fla_Fldrs.length; i++) {
            let fla_Fldr: Fla_Fldr = fla_Fldrs[i] as Fla_Fldr;
            fla_FldrsMap.set(this.getPrimaryKey(fla_Fldr), fla_Fldr);
        }

        fla_Fldrs.splice(0, fla_Fldrs.length);

        for (let i: number = 0; i < fla_FldrsTmp.length; i++) {
            let fla_FldrTmp: Fla_Fldr = fla_FldrsTmp[i] as Fla_Fldr;
            let fla_Fldr: Fla_Fldr = fla_FldrsMap.get(this.getPrimaryKey(fla_FldrTmp));

            if (fla_Fldr) {
                fla_Fldr.copyFrom(fla_FldrTmp);
            } else {
                fla_Fldr = Fla_Fldr.parse(fla_FldrTmp);
            }

            fla_Fldrs.push(fla_Fldr);
        }
    }

    compare(fla_Fldrs: Array<Fla_Fldr>, fla_FldrsTmp: Array<Fla_Fldr>) {
        if (fla_Fldrs.length != fla_FldrsTmp.length)
            return ' fla_Fldrs length mismatch.';

        for (var i: number = 0; i < fla_Fldrs.length; i++) {
            let fla_Fldr: Fla_Fldr = fla_Fldrs[i] as Fla_Fldr;
            let fla_FldrTmp: Fla_Fldr = fla_FldrsTmp[i] as Fla_Fldr;

            let diffString: string = fla_Fldr.compare(fla_FldrTmp);
            if (diffString != CommonEnums.defaults.STRING_EMPTY)
                return diffString;
        }

        return '';
    }

    toString(fla_Fldrs: Array<Fla_Fldr>) {
        let str: string = '';

        str += ' Fla_Fldr length: ' + fla_Fldrs.length + ' ';

        for (var i: number = 0; i < fla_Fldrs.length; i++) {
            let fla_Fldr: Fla_Fldr = fla_Fldrs[i] as Fla_Fldr;
            str += fla_Fldr.toString();
        }

        return str;
    }
}
